import { useEffect, useState } from 'react';

const useDeferredReady = (deps = [], timeout = 200) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);

    if (typeof window === 'undefined') {
      setReady(true);
      return undefined;
    }

    let cancelled = false;
    const markReady = () => {
      if (!cancelled) {
        setReady(true);
      }
    };

    let handle;
    if (typeof window.requestIdleCallback === 'function') {
      handle = window.requestIdleCallback(markReady, { timeout });
      return () => {
        cancelled = true;
        window.cancelIdleCallback?.(handle);
      };
    }

    handle = window.setTimeout(markReady, Math.min(timeout, 120));
    return () => {
      cancelled = true;
      window.clearTimeout(handle);
    };
  }, deps);

  return ready;
};

export default useDeferredReady;
